import React from 'react'
import {
  withRouter,
  Switch,
  Route,
  Redirect,
  BrowserRouter as Router
} from 'react-router-dom'
import UserContext from './UserContext'
import { ToastContainer } from 'react-toastify';

import AuthProvider    from './../features/auth/AuthProvider'
import Dashboard       from './../features/dashboard/index'
import Users           from './../features/users/index'
import UserAdd         from './../features/userAdd/index'
import UserView        from './../features/user/index'
import Licence         from './../features/licence/index'
import LicenceListPage from './../features/licences/index'
import Versions        from './../features/versions/index'

/**
 * ログイン必須ページ用のラッパー
 * - コンテキスト(UserContext)から user / isLoaded / updateCurrentUser を受け取り
 * - 未認証なら "/" にリダイレクト
 */
class PrivateRoute extends React.Component {

  // this.context で UserContext の値を参照できるようにする
  static contextType = UserContext

  // コンポーネントがマウントされた直後に呼び
  componentDidMount() {
    // ルーティング変更のたびにユーザ情報を最新化
    this.unlisten = this.props.history.listen(() => {
      if (this.context?.updateCurrentUser) {
        this.context.updateCurrentUser()
      }
    })
  }
  // コンポーネントが DOM から削除されるときに呼び
  componentWillUnmount() {
    // 念のため存在チェック
    if (typeof this.unlisten === 'function') {
      this.unlisten()
    }
  }

  /**
   * 
   * @returns 描画
   */
  render() {

    // ...: Spread Attributes。スプレッド演算子。
    const { component: Component, ...rest } = this.props

    // context を取り出してから使う（宣言前参照のエラーを防ぐ）
    const ctx = this.context || {}
    const isLoaded = !!ctx.isLoaded
    const currentUser = ctx.user

    // デバッグしたいときは currentUser の有無だけログに出す
    // console.log('ctx', { user: !!currentUser, isLoaded })

    // 初期化前は何も描画しない（必要ならスプラッシュをここに）
    if (!isLoaded) return null;

    // 認証済み判定（username か attributes があればOKという緩めの条件）
    const isAuthenticated = !!(currentUser && (currentUser.username || currentUser.attributes))

    return (
      <Route
        {...rest}
        render={(props) =>
          // サイン済みである
          isAuthenticated ? (
            <Component {...props} />
          ) : (
            <Redirect to={{ pathname: "/" }} />
          )
        }
      />
    )
  }
}

/**
 * 存在しないpathだった場合
 * 
 * @param {*} param0 
 * @returns 
 */
const NoMatch = ({ location }) => (
  <div>
    <h3>No match for <code>{location.pathname}</code></h3>
  </div>
)

// withRouterでhistory等を注入
const WrappedPrivateRoute = withRouter(PrivateRoute)

// コンポーネント：Headerと、pathに応じてメインビューの内容が切り替わるようになっている
// - Switch: routeのグループ化
// - exact: pathの文字列とpathNameが完全一致したときにcomponentを返す
// PrivateRouterのrenderにRouteが入っている。ログイン済みかそうではないかで表示するコンポーネントを変更している
const Routes = () => (
  <Router>
    <div>
      <Switch>
        <Route path='/' exact component={AuthProvider} />
        { /** ダッシュボード */}
        <WrappedPrivateRoute path='/dashboard'   exact component={Dashboard} />
        { /** ユーザ一覧 */}
        <WrappedPrivateRoute path='/users'       exact component={Users} />
        { /** ライセンス一覧 */}
        <WrappedPrivateRoute path='/licences'    exact component={LicenceListPage} />
        { /** バージョン一覧 */}
        <WrappedPrivateRoute path='/versions'    exact component={Versions} />

        { /** ユーザ追加 */}
        <WrappedPrivateRoute path='/user'        exact component={UserAdd} />
        { /** ユーザ詳細（and ライセンス一覧） */}
        <WrappedPrivateRoute path='/user/:id'    exact component={UserView} />
        { /** ライセンス詳細 */}
        <WrappedPrivateRoute path='/licence/:id' exact component={Licence} />

        <Route component={NoMatch} />
      </Switch>
      <ToastContainer newestOnTop={true} rtl={false} />
    </div>
  </Router>
)

export default Routes
